import { useMediaThematicBlockRandomMediafilesPaginationLazyQuery } from '@shared/api/graphql/generated';
import { FetchPolicyKeys } from '@shared/api/graphql/types';
import { useRef } from 'react';

const PAGE_SIZE = 50;

const useThematicBlockRandomMediafiles = () => {
  const ref = useRef<Set<string> | undefined>(undefined);
  const [request, result] = useMediaThematicBlockRandomMediafilesPaginationLazyQuery({
    fetchPolicy: FetchPolicyKeys.NETWORK_ONLY,
  });

  const loadRandomMediafiles = async (excludeMediafilesIds: string[], thematicContentBlockId: string) => {
    ref.current = undefined;

    await request({
      variables: {
        filters: {
          excludeMediafilesIds,
          thematicContentBlockId,
        },
        pagination: {
          pageSize: PAGE_SIZE,
        },
      },
    });
  };

  const loadMore = async (id: string, excludeMediafiles: Array<string> = []) => {
    const newIds = excludeMediafiles.filter((item) => !ref.current?.has(item));

    if (newIds.length === 0) return;
    ref.current = new Set(excludeMediafiles);

    await result.fetchMore({
      variables: {
        id,
        filters: { thematicContentBlockId: id, excludeMediafilesIds: excludeMediafiles },
        pagination: {
          pageSize: PAGE_SIZE,
        },
      },
      updateQuery: (prev, { fetchMoreResult }) => ({
        ...prev,
        result: {
          paginationInfo: {
            ...prev.result.paginationInfo,
            ...fetchMoreResult.result.paginationInfo,
          },
          result: [...(prev.result.result || []), ...(fetchMoreResult.result.result || [])],
        },
      }),
    });
  };

  return {
    request: loadRandomMediafiles,
    loadMore,
    error: result.error,
    loading: result.loading,
    mediafiles: result.data?.result.result || [],
    paginationInfo: result.data?.result.paginationInfo,
  };
};

export default useThematicBlockRandomMediafiles;
